import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.add-shared-password', {
       url: '/add-shared-password',
       params: { copyAccount: null},
       views: {
            '@company.sharing-center': 'companySharingCenterSharedPasswordsAdd'
        },
        resolve: {
            copyAccount,
        },
    });
}

/** @ngInject */
function copyAccount($stateParams) {
    return $stateParams.copyAccount;
}




// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/add/add-shared-password.state.js